import Phaser from 'phaser';
import { ModalSheetGeometry } from './ModalSheetGeometry';
import type { ModalSheetState } from './modal-sheet.types';

export class ModalSheetScrollManager<TemplateData> {
  private scrollY = 0;
  private contentTotalHeight = 0;
  private viewportW = 0;
  private viewportH = 0;

  constructor(
    private scene: Phaser.Scene,
    private geometry: ModalSheetGeometry<TemplateData>,
    private contentInner: Phaser.GameObjects.Container,
    private contentMaskGfx: Phaser.GameObjects.Graphics,
  ) {}

  public setContentHeight(height: number): void {
    this.contentTotalHeight = height;
  }

  public updateMask(state: ModalSheetState): void {
    const dims = this.geometry.getViewportDimensions(state);
    this.viewportW = dims.width;
    this.viewportH = dims.height;

    this.contentMaskGfx.clear();
    this.contentMaskGfx.fillStyle(0x3f3fff, 1);
    this.contentMaskGfx.fillRect(
      this.geometry.padding.left,
      this.geometry.padding.top,
      this.viewportW,
      this.viewportH,
    );

    const maxScroll = Math.max(0, this.contentTotalHeight - this.viewportH);
    this.scrollY = Phaser.Math.Clamp(this.scrollY, 0, maxScroll);
    this.contentInner.y = -this.scrollY;
  }

  public scroll(deltaY: number): void {
    const maxScroll = Math.max(0, this.contentTotalHeight - this.viewportH);
    if (maxScroll <= 0) return;

    this.scrollY = Phaser.Math.Clamp(this.scrollY + deltaY, 0, maxScroll);
    this.contentInner.y = -this.scrollY;
  }

  public reset(): void {
    this.scrollY = 0;
    this.contentInner.y = 0;
  }

  public isPointerOverViewport(
    containerX: number,
    containerY: number,
  ): boolean {
    const p = this.scene.input.activePointer;
    const localX = p.x - containerX;
    const localY = p.y - containerY;

    return (
      localX >= this.geometry.padding.left &&
      localX <= this.geometry.padding.left + this.viewportW &&
      localY >= this.geometry.padding.top &&
      localY <= this.geometry.padding.top + this.viewportH
    );
  }

  public getViewportDimensions(): { width: number; height: number } {
    return { width: this.viewportW, height: this.viewportH };
  }
}
